import { render, staticRenderFns } from "./YearSelect.vue?vue&type=template&id=04856d4d&scoped=true"
import script from "./YearSelect.ts?vue&type=script&lang=ts&external"
export * from "./YearSelect.ts?vue&type=script&lang=ts&external"
import style0 from "./YearSelect.scss?vue&type=style&index=0&id=04856d4d&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04856d4d",
  null
  
)

export default component.exports